import React from "react";
import { useSelector } from "react-redux";
import { icon, quote, tooltip } from "../../config";
import config from "../../env.config";
import { getTaskUrl } from "../../helper/common";
import { copyTextToClipboard, sanitizeUrl } from "../../utils/common";
import { Tooltip } from "@progress/kendo-react-tooltip";

const BookmarkPopup = ({ setPopupVisible, deleteBookmark, target }) => {
  const { tenantAppUrl } = useSelector((state) => state.app);
  const { task } = useSelector((state) => state.taskSidebar);
  const { id } = target;

  /**
   * function used for copying taskUrl
   */
  const copyTaskUrl = () => {
    let fullUrl = "";
    if (task.taskId) {
      fullUrl = (tenantAppUrl ? tenantAppUrl : config.BASE_URL.APP_URL) + sanitizeUrl(getTaskUrl(task.taskId));
    } else {
      fullUrl = (tenantAppUrl ? tenantAppUrl : config.BASE_URL.APP_URL) + window.location.pathname;
    }
    const bookmarkURL = new URL(fullUrl);
    bookmarkURL.hash = id; // Append or update the hash in the URL
    copyTextToClipboard(bookmarkURL, quote.BOOKMARK_COPIED_TO_CLIPBOARD);
    setPopupVisible(false);
  };

  return (
    <div className='d-flex p-2 align-items-center'>
      <p className='mb-0 mr-2'>{quote.BOOKMARK}</p>
      <Tooltip anchorElement='target' parentTitle position='bottom'>
        <div className="d-flex p-2 align-items-center">
          <span className='ml-2 square-icon square-icon-small'title={tooltip.COPY} onClick={copyTaskUrl}>
            {icon.COPY_CONTENT}
          </span>
          <span className='ml-2 square-icon square-icon-small' title={tooltip.DELETE} onClick={() => deleteBookmark(id)}>
            {icon.DELETE_ICON}
          </span>
          <span className='ml-2 square-icon square-icon-small' title={tooltip.CLOSE} onClick={() => setPopupVisible(false)}>
            {icon.CLOSE}
          </span>
        </div>
      </Tooltip>
    </div>
  );
};

export default BookmarkPopup;
